module.exports = __webpack_public_path__ + "img/login.38796798.svg";